<template>
    <div>
        <div>
            Sleep Time Player
        </div>
        <div v-if="statusText">
            {{ statusText }}
        </div>
        <div v-if="errorText" class="alert alert-danger">
            {{ errorText }} 
            <button class="btn btn-sm btn-danger" @click="errorText=''">X</button>
        </div>
        <div>
            <ContentPlayerMini 
                v-show="true" 
                :content="playingContent" 
                :progress="playerProgress" 
                :autoplay="false"
                :enableNextButton="true" 
                :enablePreviousButton="true"

                @player-save="handlePlayerSave" 
                @player-completed="handlePlayerCompleted"
                @player-next="handlePlayerNext"
                @player-previous="handlePlayerPrevious"/>
        </div>
    </div>
</template>
<script>
import SubscriptionApi from "../scripts/SubscriptionApi";
import UserService from "../scripts/UserService";
import ContentPlayerMini, { ContentPlayerInputModel } from "../components/ContentPlayerMini.vue";
import DownloadsRepository, { DownloadListItem } from '../scripts/DownloadsRepository';

const subApi = new SubscriptionApi();
const downloadsRepository = new DownloadsRepository();

export default {
    components: { ContentPlayerMini },
    data: () => ({
        statusText: "initializing",
        playingContent: null,
        playerProgress: 0,
        errorText: "",
        sub: null,
    }),
    async mounted() {
        let usr = new UserService();
        let user = usr.getLoggedInUser();
        if (!user)
            return;

        await this.loadCurrentIndex();
    },
    methods: {
        //I don't think we want this to do anything 
        handlePlayerSave() { },

        async handlePlayerCompleted() {
            await this.progressIndexForward();
        },

        async handlePlayerNext() {
            await this.progressIndexForward();
            await this.loadCurrentIndex();
        },

        async handlePlayerPrevious() {
            let cIndex = this.content.findIndex(c => c.guid == this.sub.index.guid || c.title == this.sub.index.title || c.url == this.sub.index.url);
            let previous = this.content[cIndex + 1];
            await subApi.updateIndex(this.sub.url, previous.title, previous.guid, previous.url);
            await this.loadCurrentIndex();
        },

        async loadCurrentIndex() {
            this.statusText = 'getting current index';
            let subs = await subApi.getSubscriptions();
            let hftmt = subs.find(s => s.title == "Hello From The Magic Tavern");
            this.sub = hftmt;
            if (hftmt.index?.title) {
                //find index
                this.statusText = 'getting podcast episodes';
                this.content = await subApi.getContent(hftmt.url);

                //find index and download
                let fullContentIndex = this.content.find(c => c.url == hftmt.index.url || c.guid == hftmt.index.guid || c.title == hftmt.index.title);

                let hftmtDownloadsList = await downloadsRepository.getDownloadsForSubscription(this.content.rssUrl);
                let downloadedContentInfo = hftmtDownloadsList.find(c => c.contentUrl == hftmt.index.url || c.title == hftmt.index.title);

                let downloadContent = null;
                this.statusText = 'downloading';
                if(!downloadedContentInfo) {
                    downloadContent = await downloadsRepository.download(
                        fullContentIndex.title,
                        fullContentIndex.guid,
                        fullContentIndex.url,
                        fullContentIndex.date,
                        fullContentIndex.description,
                        fullContentIndex.watched,
                        fullContentIndex.rssUrl,
                        fullContentIndex.progress,
                        fullContentIndex.totalDuration);
                    this.statusText = 'downloaded'
                } else {
                    downloadContent = await downloadsRepository.getDownloadData(
                        fullContentIndex.title,
                        fullContentIndex.guid,
                        fullContentIndex.url,
                        fullContentIndex.rssUrl);
                    this.statusText = 'found downloaded'
                }

                if(!downloadContent) {
                    this.statusText = 'error';
                    this.errorText = 'unable to download or fetch downloaded content'
                }

                this.statusText = '';
                this.playingContent = new ContentPlayerInputModel(
                    downloadContent.title,
                    downloadContent.guid,
                    downloadContent.contentUrl,
                    null,
                    hftmt.url,
                    true);
            } else {
                this.errorText = "HFTMT not found in api!";
            }
        },

        async progressIndexForward() {
            let cIndex = this.content.findIndex(c => c.guid == this.sub.index.guid || c.title == this.sub.index.title || c.url == this.sub.index.url);
            let next = this.content[cIndex - 1];
            await subApi.updateIndex(this.sub.url, next.title, next.guid, next.url);
        }
    }
}
</script>